import React from 'react';
import PropTypes from 'prop-types';
import dashboardCardIconHeaderSx from './DashboardCardIconHeader.styles';
import { useTheme } from '@mui/material/styles';

const DashboardCardIconHeader = React.memo(({ icon }) => {
    const theme = useTheme();
    const sx = dashboardCardIconHeaderSx(theme);
    let clone = React.cloneElement(icon, {
        style: sx.icon,
    });

    return (
        <div>
            <span style={sx.message}>{clone}</span>
        </div>
    );
});

DashboardCardIconHeader.propTypes = {
    icon: PropTypes.PropTypes.node.isRequired,
};

export default DashboardCardIconHeader;
